// THE APP STORE ITEM — its id and its link, built in ONE place.
//
// A workspace app's App Store item is `app.<owner>.<key>`: the id of the
// store's own row (functions/index.js `_projectToCatalogItem`, kind 'app') and
// the `?item=` of every link to the app's page. The store reads the id back
// from the address (`?item=app.*` opens the App Store surface and selects the
// row with that id), so a link built anywhere else must spell it exactly as
// the row does. Every builder asks this file: the store's rows, the /add-app
// catalog card's Details link and the search suggestion's App Store row
// (workspace), an AI card's App Store link (canvas canvasAnswerStoreLink) and
// the apps hub's Manage, which keeps its own route (the concierge,
// 2026-10-31: "one builder, with no tech debt left").
//
// Light and self-contained: the shell's surfaces call it before any
// /marketplace route mounts, so the shell's eager slice registers this file
// (functions/eagerSlice.js), and functions/index.js imports it for the
// store's rows and re-exports it for every context that folds the full
// barrel in. Called the DOMQL way: `el.call('appStoreItemLink', owner, key)`.

// el.call('appStoreItemId', owner, key) -> 'app.<owner>.<key>'. null when the
// owner or the key is not a slug (a letter or a digit first, then letters,
// digits, `_` and `-`): a dot, a space, a slash, a `?` or an empty or
// non-string part names no item the store can read back.
export function appStoreItemId(owner, key) {
  const slug = (v) => typeof v === 'string' && /^[A-Za-z0-9][A-Za-z0-9_-]*$/.test(v)
  if (!slug(owner) || !slug(key)) return null
  return 'app.' + owner + '.' + key
}

// el.call('appStoreItemLink', owner, key, route) -> '<route>?item=app.<owner>.<key>'.
// `route` is a path with no query; with none, the App Store's own
// '/marketplace' (the apps hub passes the catalogue's '/apps/store'). null
// when there is no id.
export function appStoreItemLink(owner, key, route) {
  const id = this.call('appStoreItemId', owner, key)
  if (!id) return null
  return (typeof route === 'string' && route ? route : '/marketplace') + '?item=' + id
}
